.card-widget {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.loading-and-empty-state {
    display: flex;
    justify-content: center;
    min-height: 80px;
    padding-bottom: 8px;
}

/* Some of our jQuery DOM selectors do not explictly search for hidden elements,
so we use this hacky class to hide the content */
.jQuery-compatible-hidden {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    top: -10000px;
    left: -10000px;
    overflow: hidden;
}

.content-shown {
    padding-top: 8px;
    padding-bottom: 8px;
}

.has-padding {
    padding: 0 12px 12px 12px;
}

/* Left align our tabs with the widget header icons */
.tab-container > div:first-child {
    padding-left: 12px;
}

.card-widget--full-width {
    width: 100%;
}

.card-widget--full-height {
    height: 100%;
    box-sizing: border-box;
}

.card-widget--bordered {
    border: 1px solid var(--grey-xlt);
}

.card-widget--bordered:hover {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    border-color: var(--grey-lt);
}

.card-widget--ai-variant {
    background-color: white;

    .loading-and-empty-state {
        min-height: 0;
        padding: 16px;
    }
}

.card-widget--ai-variant:hover {
    border-color: var(--ai-purple-pink);
    box-shadow: 0 1px 2px var(--ai-purple-box-shadow);
}
